import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import TRANSLATIONS from './translations@default.json';

const OutOfStock = ({ deals, classes }) => {
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	return (
		<div
			className={classnames(
				classes,
				'flex justify-center items-center rounded leading-snug bg-bread p-2 text-title-sm text-error text-center',
				{
					'flex-col': !CustomCategoriesEnabled,
					'xl:flex-col': CustomCategoriesEnabled,
				}
			)}>
			{!deals && (
				<span
					className={classnames('ico ico-clock text-title-lg text-error', {
						'mr-1': CustomCategoriesEnabled,
					})}></span>
			)}
			<span className="text-title-sm text-error">{TRANSLATIONS.OOS}</span>
		</div>
	);
};

export default OutOfStock;
